import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { Seo } from "@/components/common/Seo";
import { useTranslate } from "@/i18n";

const mailLink = (
  <a
    href="mailto:hello@farmly.se"
    className="underline underline-offset-4 hover:text-foreground transition-colors"
  >
    hello@farmly.se
  </a>
);

const IntegritetPage = () => {
  const t = useTranslate();
  return (
    <div className="flex min-h-screen flex-col">
      <Seo title={t("privacy.seoTitle")} description={t("privacy.seoDescription")} />
      <SiteHeader />
      <main className="flex-1 container max-w-prose px-4 py-16 md:py-24 space-y-10">
        <header className="space-y-3">
          <h1 className="font-display text-2xl md:text-3xl font-medium text-foreground">{t("privacy.title")}</h1>
          <p className="text-muted-foreground leading-relaxed">{t("privacy.lead")}</p>
        </header>

        <section className="space-y-2">
          <h2 className="font-display text-lg font-medium text-foreground">{t("privacy.section.collect.title")}</h2>
          <p className="text-muted-foreground leading-relaxed">{t("privacy.section.collect.intro")}</p>
          <ul className="list-disc list-inside text-muted-foreground leading-relaxed space-y-1">
            <li>{t("privacy.collect.item1")}</li>
            <li>{t("privacy.collect.item2")}</li>
            <li>{t("privacy.collect.item3")}</li>
            <li>{t("privacy.collect.item4")}</li>
            <li>{t("privacy.collect.item5")}</li>
            <li>{t("privacy.collect.item6")}</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="font-display text-lg font-medium text-foreground">{t("privacy.section.use.title")}</h2>
          <p className="text-muted-foreground leading-relaxed">{t("privacy.section.use.intro")}</p>
          <ul className="list-disc list-inside text-muted-foreground leading-relaxed space-y-1">
            <li>{t("privacy.use.item1")}</li>
            <li>{t("privacy.use.item2")}</li>
            <li>{t("privacy.use.item3")}</li>
            <li>{t("privacy.use.item4")}</li>
            <li>{t("privacy.use.item5")}</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="font-display text-lg font-medium text-foreground">{t("privacy.section.share.title")}</h2>
          <p className="text-muted-foreground leading-relaxed">{t("privacy.section.share.body")}</p>
        </section>

        <section className="space-y-2">
          <h2 className="font-display text-lg font-medium text-foreground">{t("privacy.section.storage.title")}</h2>
          <p className="text-muted-foreground leading-relaxed">{t("privacy.section.storage.body")}</p>
        </section>

        <section className="space-y-2">
          <h2 className="font-display text-lg font-medium text-foreground">{t("privacy.section.rights.title")}</h2>
          <p className="text-muted-foreground leading-relaxed">{t("privacy.section.rights.body")}</p>
        </section>

        <section className="space-y-2">
          <h2 className="font-display text-lg font-medium text-foreground">{t("privacy.section.contact.title")}</h2>
          <p className="text-muted-foreground leading-relaxed">
            {t("privacy.section.contact.bodyBefore")} {mailLink}.
          </p>
        </section>

        <section id="data-deletion" className="space-y-2 pt-4 border-t border-border/15">
          <h2 className="font-display text-lg font-medium text-foreground">{t("privacy.section.deletion.title")}</h2>
          <p className="text-muted-foreground leading-relaxed">
            {t("privacy.section.deletion.body1Before")} {mailLink}.
          </p>
          <p className="text-muted-foreground leading-relaxed">{t("privacy.section.deletion.body2")}</p>
          <p className="text-muted-foreground leading-relaxed">{t("privacy.section.deletion.body3")}</p>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
};

export default IntegritetPage;
